<template>
  <div class="historyInfoBoxes">
    <v-row no-gutters class="checkClientInfo">
      <v-col
        v-for="(rec, index) in detail"
        :key="index"
        v-bind:class="{
          boxStyle: true,
          boxStyleFirst: index === 0
        }"
      >
        <div class="titleStyle">
          <span class="titleText"> {{ $t(rec.title) }}</span>
        </div>
        <div class="contentsStyle">
          <slot :name="'box' + index" v-bind:item="rec">
            <div v-if="rec.supplierName" class="mb-1 font-weight-bold">
              {{ rec.supplierName }}
            </div>
            <div v-if="rec.name" class="mb-1 font-weight-bold">
              {{ rec.name + $t('sale.sale_mr') }}
            </div>
            <div>〒{{ rec.postalCode }}</div>
            <div>{{ rec.address }}</div>
            <div v-if="rec.place">{{ rec.place }}</div>
            <div>{{ $t('common.input_phone-number') + ':' + rec.phone }}</div>
            <div v-if="rec.fax">
              {{ $t('common.input_fax-number') + ':' + rec.fax }}
            </div>
          </slot>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    detail: {
      type: Array,
      require: true,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.historyInfoBoxes {
  width: 100%;

  .titleStyle {
    background-color: rgba(151, 198, 234, 0.1);
    border-bottom: 1px solid #d8d8d8;
    height: 36px;
    display: table;
    width: 100%;
    text-align: center;
  }
  .titleText {
    display: table-cell;
    vertical-align: middle;
    background-color: #fafafb;
  }
  .contentsStyle {
    // height: 130px;
    padding: 15px 41px;
  }
  .boxStyle {
    border: 1px solid #d8d8d8;
    margin-top: -1px;
    margin-bottom: -1px;
    // margin-left: -1px;
    margin-right: -1px;
  }
  .boxStyle:last-child {
    margin-right: -1px;
  }
  .boxStyleFirst {
    margin-left: -1px;
  }
}
</style>
